import { CustomerRow } from "../components/customers/CustomerRow"
import { useEffect, useState } from "react"
import "./customers.css"

export function Customers() {
    const [users, setUsers] = useState(null)

    useEffect(() => {
        async function fetchUsers() {
            const response = await fetch(`http://localhost:3001/api/users`)
            //const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/users`)
            const json = await response.json()

            if(response.ok) {
                setUsers(json)
            }
        }

        fetchUsers()
    }, [])

    return (
        <div className="customers">
            <h4>Customers</h4>

            <div className="admin-users border rounded-1 mt-4 table-wrapper">
                <table className="users-table mt-1 mb-3">
                    <tbody>
                        <tr className="table-header">
                            <td>Name</td>
                            <td>Email</td>
                            <td>Phone</td>
                            <td>Joined</td>
                            <td className="text-end pe-4">Action</td>
                        </tr>
                    </tbody>
                </table>

                {
                    users && users.map((e, i) => (
                        <CustomerRow key={i} user={e} />
                    ))
                }
            </div>
        </div>
    )
}